import React, { useRef, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Close from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import IconButton from "@mui/material/IconButton";
import CheckRounded from "@mui/icons-material/CheckRounded";
import ContentCopyRounded from "@mui/icons-material/ContentCopyRounded";

import usePdfSignedUrl from "../../../../hooks/usePdfSignedUrl";
import useNotification from "../../../../hooks/notification";

const styles = {
  input: {
    display: "block",
    opacity: 0,
    height: 0,
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
  },
};

export default function ShareModal({
  onClose,
  inventoryRequest,
  resourceType = "inventory_request_pdfs",
  resourceId,
  shareLink,
}) {
  const inputCopyText = useRef();
  const [copied, setCopied] = useState(false);
  const { notifySuccess } = useNotification();
  const resolvedResourceId = resourceId || inventoryRequest?.id;
  const { pdfUrl } = usePdfSignedUrl(resourceType, resolvedResourceId, {
    enabled: !shareLink,
  });
  const computedShareLink =
    shareLink || pdfUrl || "";

  function handleCopy(e) {
    setCopied(true);
    e.preventDefault();
    const link = inputCopyText.current;
    const range = document.createRange();
    range.selectNode(link);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    const successful = document.execCommand("copy");
    if (successful) {
      notifySuccess("Link has been copied!");
    }
  }

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(t);
  }, [copied]);

  return (
    <Dialog open maxWidth="xs" onClose={onClose}>
      <DialogTitle>
        <Typography align="center" fontSize={20} fontWeight={500} color="textSecondary">
          Share
        </Typography>
        <IconButton onClick={onClose} sx={styles.closeButton}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Box display="flex" justifyContent="center" mb={1} mt={1}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={copied ? <CheckRounded /> : <ContentCopyRounded />}
              onClick={handleCopy}
              disabled={!computedShareLink}
            >
              Copy Link
            </Button>
          </Box>
          <a style={styles.input} href={computedShareLink} ref={inputCopyText}>
            {computedShareLink}
          </a>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
